import React, {useContext, useEffect, useState} from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { UTTaskMemoListItem } from '../../fms.data/models/UTTaskMemoListItem';
import { getJobNameByTbName, JobNames } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../uiControls/infoArea/InfoAreaDrawer';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { TableColumn, TableSettings, utTaskMemoListItem } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { MemoOpTypeRenderer } from '../common/commonListRenderers';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';
import PrimaryInverseButton from '../../ui/PrimaryInverseButton';
import { getDetailSecLinkInfo, getJobNameBySourceType, getListUrlWithSecCheck, getOredrByJobName } from '../../util';
import ApplicationContext from '../../ApplicationContext';
import { useSecureNavigate } from '../../hooks/useSecureNavigate';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';

/*
function useSelectedOperations() {
  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  // const history = useHistory();
  //const operation = 'accounting';

  // const selectedElement = jobListContext.selectedElement as UTTaskMemoListItem;

  // const [showGlobalOkDialog] = useGlobalOkDialog();
  // const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  // async function create() {
  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/add`, NavigationType.newPage);
  // }

  // async function deleteEntity() {
  //   if (!selectedElement) {
  //     return;
  //   }
  
  //   const doDelete = await showGlobalYesNoDialog(
  //     <div>
  //       <h3>Confirm to Delete?</h3>
  //     </div>
  //   );

  //   if (doDelete) {
  //     const apiResult = await appContext.api.deleteJobDetail(JobNames.PrepaidExpenseAdjustment, {
  //       id: selectedElement.id,
  //       pimsLinkId: 0
  //     });
  //     if (apiResult && apiResult.success) {
  //       jobListContext.reloadData();
  //     } else {
  //       const message = apiResult?.message ?? 'Cannot delete!';
  //       await showGlobalOkDialog(message);
  //     }
  //   }
  // }

  // async function edit() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/edit`)) {
  //     await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/edit/${id}`, NavigationType.newPage);
  // }

  // async function view() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   const id = selectedElement.id;

  //   const viewUrl = `/${operation}/acPrepaidExpenseAdjustment/view/${id}`;

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
  //     await showGlobalOkDialog(<p>View operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, viewUrl, NavigationType.newPage);
  // }

  // async function copy() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/add?copyId=${id}`, NavigationType.newPage);
  // }

  return {};
}
*/

function getDetailUrlByJobName(jobName: string, tbId: number, tbName: string = '', id: number = 0, bltbName: string = ''){
  switch(jobName){
    case JobNames.OIMbl:                    return `/oceanImport/mbl/view/${tbId}`;
    case JobNames.OIHbl:                    return `/oceanImport/hbl/view/${tbId}`;
    case JobNames.OEMbl:                    return `/oceanExport/mbl/view/${tbId}`;
    case JobNames.OEHbl:                    return `/oceanExport/hbl/view/${tbId}`;

    case JobNames.AIMbl:                    return `/airImport/mawb/view/${tbId}`;
    case JobNames.AIHbl:                    return `/airImport/hawb/view/${tbId}`;
    case JobNames.AEMbl:                    return `/airExport/mawb/view/${tbId}`;
    case JobNames.AEHbl:                    return `/airExport/hawb/view/${tbId}`;
    case JobNames.OtherOP:                  return `/otherShipment/otherShipment/view/${tbId}`;
    case JobNames.WHRcv:                    return `/warehousing/receiving/view/${tbId}`;
    case JobNames.WHShip:                   return `/warehousing/shipping/view/${tbId}`;
    
    case JobNames.Invoice:                  return `/accounting/invoice/view/${getJobNameByTbName(bltbName)}/${id}/${tbId}`;
    case JobNames.GInvo:                    return `/accounting/acGeneralInvoice/view/${tbId}`;
    case JobNames.CrDb:                     return `/accounting/crdb/view/${getJobNameByTbName(bltbName)}/${id}/${tbId}`;
    case JobNames.Bill:                     return `/accounting/bill/view/${getJobNameByTbName(bltbName)}/${id}/${tbId}`;
    case JobNames.GBill:                    return `/accounting/acGeneralBill/view/${tbId}`;
    case JobNames.CustPayment:              return `/accounting/acCustomerPayment/view/${tbId}`;
    case JobNames.BillPayment:              return `/accounting/acBillPayment/view/${tbId}`;
    case JobNames.AgntPayment:              return `/accounting/acAgentPayment/view/${tbId}`;
    case JobNames.CCPayment:                return `/accounting/acCCPayment/view/${tbId}`;
    case JobNames.Payroll2:                 return `/accounting/acPayroll2/view/${tbId}`;

    case JobNames.Company:                  return `/common/companies/view/${tbId}`;
    case JobNames.OIContainer:              return `/common/joblistview/OICN/oceanImport`;
    case JobNames.OEContainer:              return `/common/joblistview/OECN/oceanExport`;
    case JobNames.OtherContainer:           return `/common/joblistview/OTOPC/otherShipment`;

    case JobNames.OIQuotation:              return `/oceanImport/quotation/view/${tbId}`;
    case JobNames.OEQuotation:              return `/oceanExport/quotation/view/${tbId}`;
    case JobNames.AIQuotation:              return `/airImport/quotation/view/${tbId}`;
    case JobNames.AEQuotation:              return `/airExport/quotation/view/${tbId}`;
    case JobNames.OtQuotation:              return `/otherShipment/quotation/view/${tbId}`;
    
    case JobNames.BankRecon:                return `/accounting/acBankRecon/view/${tbId}`;
    case JobNames.BankTransfer:             return `/accounting/acBankTransfer/view/${tbId}`;
    case JobNames.SalesTaxReturn:           return `/accounting/acSalesTaxReturn/view/${tbId}`;

    default : return '';
  }
}

function useMemoAllOperations(){
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const secureNavigate = useSecureNavigate();

  function switchToOp(memo: UTTaskMemoListItem|null){
    if (!memo){
      return;
    }

    const jobName = getJobNameBySourceType(memo.opType);
    const isContainerJob = [JobNames.OIContainer,JobNames.OEContainer,JobNames.OtherContainer].includes(jobName);

    if(isContainerJob){
      const columnId = [JobNames.OIContainer, JobNames.OEContainer].includes(jobName) ? 'containerId': 'id';
      const listUrl = getListUrlWithSecCheck(appContext, jobName, showGlobalOkDialog);
      if (!listUrl) return;
      
      const orderBy = getOredrByJobName(jobName);
      jobListContext.setFilterForScreenExternally(listUrl, columnId, '', memo.tbId.toString(), orderBy, false, true);
      openNewPage(history, listUrl, NavigationType.newPage);

    } else {
      const { secTask, detailUrl } = getDetailSecLinkInfo(jobName, memo.tbId, memo.bltbId, memo.bltbName);
      if (!secTask || !detailUrl) return;

      secureNavigate(secTask, () =>
        jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(detailUrl, [detailUrl, detailUrl.replace('/view', '/edit')])
      );
    }
  }

  return {switchToOp};

}

function  RefNoRenderer({cell, row, data}: any){
    const {switchToOp} = useMemoAllOperations();

  // if(!cell.value){
  //   return <div className="ifms-table-align-left">{cell.value}</div>;
  // }

  return <PrimaryInverseButton onClick={() => switchToOp(data[row.index])} style={{width: '100%', lineHeight:'1em', textAlign: 'left' }}>{cell.value ? cell.value : 'Empty #'}</PrimaryInverseButton>
}


function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  //const { create, deleteEntity, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  //const appContext = useContext(ApplicationContext);
  // const listSec = findSecurityTask(appContext, FmsSecTask.AcctPrepaidAdjustment);
  // const selectedElement = jobListContext.selectedElement as UTTaskMemoListItem;

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  return (
    // <div className="ifms-common-no-vertical-separator">
    //   <UniqueLinkButton display="primary" size="regular" link={''} disabled
    //                     label={<span><FontAwesomeIcon icon={faPlus}/>&nbsp; New</span>}/>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={ViewIcon}/>&nbsp; View</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={EditIcon}/>&nbsp; Edit</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={DeleteIcon}/>&nbsp; Delete</PrimaryButton>&nbsp;
    // </div>
    <></>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  //const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.MemoList}
      jobId={(jobListContext.selectedElement as UTTaskMemoListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 *
 * @class MemoAllListView
 * @extends {AbstractListView}
 */
class MemoAllListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.MemoList,
      'UTTaskMemoListItem',
      UTTaskMemoListItem.calculateSearchParameters(search,UTTaskMemoListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: UTTaskMemoListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }


  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.MemoList, 'UTTaskMemoListItem',
      UTTaskMemoListItem.calculateSearchParameters(search, UTTaskMemoListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  UTTaskMemoListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      { 
        accessor: 'opType',
        renderer: MemoOpTypeRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      }
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return UTTaskMemoListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.dataIndex === 'refNo') colRenderer.Cell = RefNoRenderer;
      else if(x.type === XCol.XCellType.Double) colRenderer.Cell = (props:any) => <FloatRenderer {...props} decimals={2} />;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'createdAt',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  utTaskMemoListItem;
    const cols = UTTaskMemoListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  
  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: UTTaskMemoListItem) {
    return '';
  }

  getListViewTitle() {
    return 'Memo List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.MemoList} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default MemoAllListView;